var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 68,
    viewBox: "0 0 85 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-image",
    "data-name": "001-image",
    transform: "translate(-85.32 -0.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M157.821,81.493a8.5,8.5,0,1,0-8.5-8.5A8.508,8.508,0,0,0,157.821,81.493Zm0,0",
    transform: "translate(-51.25 -51.25)",
    fill: "#eeeeee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M159.695.492H95.945A10.64,10.64,0,0,0,85.32,11.118V57.867A10.64,10.64,0,0,0,95.945,68.493h63.75A10.64,10.64,0,0,0,170.32,57.867V11.118A10.64,10.64,0,0,0,159.695.492Zm-63.75,8.5h63.75a2.126,2.126,0,0,1,2.125,2.125V41.288L148.395,25.622a7.613,7.613,0,0,0-5.7-2.613,7.429,7.429,0,0,0-5.678,2.682L121.232,44.637l-5.142-5.13a7.46,7.46,0,0,0-10.54,0L93.821,51.233V11.118A2.125,2.125,0,0,1,95.945,8.992Zm0,0",
    fill: "#eeeeee"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.3f3fdda211f2df9051dbf4264ba5c5e6.svg";
export { ForwardRef as ReactComponent };